import { Typography } from '@mui/material';
import React from 'react';

import { SummaryItem } from '~/components/MyWorkspace/SummaryItem';
import { getInitials } from '~/services/Employee';
import { People } from '~/services/Http';

import { useSxStyles } from './useStyles';

export interface Props {
  employee: People.EmployeeProfileDto;
}

export const EmployeeTopInfo: React.FC<Props> = ({ employee }) => {
  const sxStyles = useSxStyles();

  return (
    <SummaryItem
      avatarProps={{
        alt: getInitials(employee.firstName, employee.lastName),
        src: employee.profilePic,
        sx: sxStyles.avatar,
      }}
      listItemProps={{ disableGutters: true, alignItems: 'flex-start' }}
      primaryElement={
        <Typography variant="h6">{`${employee.firstName} ${employee.lastName}`}</Typography>
      }
      secondaryElement={
        <Typography variant="body2">
          {employee.unit.name}
          <br />
          {employee.positionName.value}
        </Typography>
      }
    />
  );
};
